import React from 'react';
import { Button, Input, Select, message, DatePicker } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import { convertOption, generateOptions } from '../../shared/selectFn';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from "moment";

const Option = Select.Option;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class PlanFilter extends React.Component {
    state = {
        searchParams: {
            startDate: moment().add(1, 'months').format(monthFormat),
            endDate: moment().add(12, 'months').format(monthFormat),
        },
        areaList: [],
        businessList: [],
    }
    
    componentDidMount() {
        this.search();
        this.loadAreaList();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, data => {
            if (!data.error) {
                this.setState({ areaList: data.data });
            } else {
                message.error(data.error);
            }
        });
    }

    search = () => {
        const { searchParams } = this.state;
        const { startDate, endDate } = searchParams;
        if (!startDate) {
            message.warning('请选择筛选开始时间');
            return;
        } else if (!endDate) {
            message.warning('请选择筛选结束时间');
            return;
        }
        this.props.search({ ...searchParams });
    }

    export = () => {
        this.props.export();
    }

    handleInputChange = (field, e) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        if (field === 'lineOfBusiness') {
            searchParams.secondLineName = undefined;
        }
        this.setState({ searchParams });
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleBeignMonth = (date, dateString) => {
        const { searchParams } = this.state;
        const { endDate } = searchParams;
        if (endDate && moment(endDate) < date) {
            message.warning('筛选开始时间不能大于筛选结束时间');
            return;
        }
        searchParams.startDate = dateString;
        this.setState({ searchParams });
    }

    handleEndMonth = (date, dateString) => {
        const { searchParams } = this.state;
        const { startDate } = searchParams;
        if (startDate == '') {
            message.warning('请先选择筛选开始时间');
            searchParams.endDate = '';
        } else if (startDate && dateString && moment(startDate) > date) {
            message.warning('筛选结束时间不能小于筛选开始时间');
            return;
        } else {
            searchParams.endDate = dateString;
        }
        this.setState({ searchParams });
    }

    handleChange = ({ value, text }, key) => {
        const { searchParams } = this.state;
        searchParams[`${key}MainId`] = value;
        searchParams[`${key}Name`] = text;
        if (key === 'hospital') {
            searchParams.departmentId = undefined;
            searchParams.departmentName = undefined;
        }
        this.setState({ searchParams });
    }

    render() {
        const { areaList, searchParams, businessList } = this.state;
        const { startDate, endDate, userName, leaderUserName, hospitalMainId, hospitalName, departmentName, lineOfBusiness } = searchParams;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const areaListOption = areaList.map(d => <Option key={d.investigationAreaId}>{d.investigationAreaName}</Option>);
        const showStartDate = startDate ? moment(startDate) : null;
        const showEndDate = endDate ? moment(endDate) : null;
        return (
            <div className="search-bar" style={{ marginBottom: 16 }}>
                <div className="search-item" style={{height: 30}}>
                    <label htmlFor="" className="ui-label">人员安排时间</label>
                    <MonthPicker
                        style={{width: 80}}
                        value={showStartDate}
                        format={monthFormat}
                        onChange={this.handleBeignMonth}
                        allowClear={true}
                    />
                </div>
                <div className="search-item" style={{height: 30}}>
                    <label htmlFor="" className="ui-label">至</label>
                    <MonthPicker
                        style={{width: 80}}
                        value={showEndDate}
                        format={monthFormat}
                        onChange={this.handleEndMonth}
                        allowClear={true}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">姓名/工号</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 142 }}
                        params={{ limit: 20 }}
                        value={userName}
                        placeholder="输入姓名/工号检索"
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={option => this.handleChange(option, 'user')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">工作城市 </label>
                    <Input
                        placeholder="请输入"
                        onChange={this.handleInputChange.bind(this, 'workCity')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">主管领导</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 142 }}
                        value={leaderUserName}
                        params={{ limit: 20, dimissionStatus: 'WORKING' }}
                        placeholder="输入姓名/工号检索"
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={option => this.handleChange(option, 'leaderUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">项目领域</label>
                    <Select placeholder="请选择" allowClear={true} style={{ width: 100 }} onChange={value => this.handleSelectChange(value, 'investigationAreaId')}>
                        {areaListOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">项目编号</label>
                    <Input
                        placeholder="请输入"
                        onChange={this.handleInputChange.bind(this, 'investigationCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">项目简称</label>
                    <Input
                        placeholder="请输入"
                        onChange={this.handleInputChange.bind(this, 'investigationName')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">项目中承担的角色</label>
                    <Select placeholder="请选择" allowClear={true} style={{ width: 100 }} onChange={value => this.handleSelectChange(value, 'roleCode')}>
                        <Option value='PM'>PM</Option>
                        <Option value='PA'>PA</Option>
                        <Option value='CRC'>CRC</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">医院</label>
                    <SearchRetrieve
                        keyword='hospitalName'
                        style={{ width: 162 }}
                        params={{ limit: 20 }}
                        value={hospitalName}
                        placeholder="输入医院名称检索"
                        url={API_URL.hospital.queryHospitalMainList}
                        config={{ id: 'hospitalMainId', name: 'hospitalMainName'}}
                        onChange={option => this.handleChange(option, 'hospital')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">科室</label>
                    <SearchRetrieve
                        keyword='hospitalDepName'
                        style={{ width: 162 }}
                        params={{ limit: 20, hospitalId: hospitalMainId }}
                        disabled={!hospitalMainId}
                        value={departmentName}
                        placeholder="输入科室名称检索"
                        url={API_URL.hospital.queryDepWhenAddDoctor}
                        config={{ id: 'hospitalDepartmentId', name: 'departmentLocalName' }}
                        onChange={option => this.handleChange(option, 'department')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">业务线</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        value={lineOfBusiness}
                        onChange={value => this.handleSelectChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label className="ui-label">执行业务线二级分类</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        disabled={!lineOfBusiness}
                        value={searchParams.secondLineName}
                        onChange={value => this.handleSelectChange(value, 'secondLineName')}
                    >
                        {secondLineOption}
                    </Select>
                </div>
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                </div>
            </div>
        );
    }
}

export default PlanFilter;



// WEBPACK FOOTER //
// ./src/components/user/userPlan/Filter.js